import { render, staticRenderFns } from "./DashboardKabayan.vue?vue&type=template&id=4db78590"
import script from "./DashboardKabayan.vue?vue&type=script&lang=js"
export * from "./DashboardKabayan.vue?vue&type=script&lang=js"
import style0 from "./DashboardKabayan.vue?vue&type=style&index=0&id=4db78590&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports